import { Icons } from '@/styles/Icon';
import { CardTitle } from '@/styles/Typography';
import React from 'react';
import { styled } from 'styled-components';

interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description
}) => {
  const renderIcon = () => {
    switch (icon) {
      case 'shield':
        return (
          <img src={Icons.badge_1} alt="Shield Icon" />
        );
      case 'dollar':
        return (
          <img src={Icons.badge_2} alt="Thunder Icon" />
        );
      case 'music':
        return (
          <img src={Icons.badge_3} alt="Download Icon" />
        );
      case 'lock':
        return (
          <img src={Icons.badge_4} alt="People Icon" />
        );
      default:
        return null;
    }
  };

  return (
    <Card>
      <IconWrapper>{renderIcon()}</IconWrapper>
      <CardTitle style={{ marginBottom: '16px', fontWeight: '700' }}>{title}</CardTitle>
      <Description>{description}</Description>
    </Card>
  );
};

const Card = styled.div`
  background: ${({ theme }) => theme.colors.bgWhite};
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  box-shadow: ${({ theme }) => theme.shadows.card};
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
  }
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: ${({ theme }) => theme.colors.bgLightBlue};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
`;

const Description = styled.p`
  font-family: ${({ theme }) => theme.fonts.pretendard};
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.fontBlackText};
  line-height: 1.6;
`;